// Admin utility functions
export const isAdminUser = (user: any): boolean => {
  return user && user.is_admin && user.email && user.email.endsWith('@primenumbers.in')
}

export const isPrimeNumbersEmail = (email: string): boolean => {
  return Boolean(email && email.endsWith('@primenumbers.in'))
}

export const getAdminAccessLevel = (user: any): 'none' | 'limited' | 'full' => {
  if (!user || !user.email) return 'none'
  
  if (!isPrimeNumbersEmail(user.email)) return 'none'
  
  if (user.is_admin) return 'full'
  
  return 'limited' // primenumbers.in email but not admin
}